import AppLayout from 'layouts/App';

const App = AppLayout();

export default App;



// WEBPACK FOOTER //
// ./src/routes/component.js